<template>
  <div class="short-container">
    <div class="row h-100 w-100 normal-container">
      <div
        :class="[
          isFull ? 'col-12' : 'col-7',
          'bg-slate-500 pl-0 col-transitions',
        ]"
      >
        <div
          class="video-container"
          v-if="!is_small_device"
        >
          <div class="video-container__image h-100 w-100">
            <img
              :src="placeholder"
              :alt="flix.name"
              :data-src="flix.portraitImage"
            />
          </div>
          <VideoContainer
            :flix="flixItem"
            v-bind:loadingItem="loadingItem"
            v-bind:itemName="flix?.name"
            v-bind:totalItems="flix?.items?.length"
            v-bind:currentItemCount="currentItemNumber"
            v-bind:access="access"
            v-bind:smallDevice="is_small_device"
            v-bind:item_image="flix.portraitImage"
            @openPlansModal="triggerPlansModal"
            @handleNext="triggerNext"
            @handlePrev="triggerPrivous"
            @handleCheckMoves="handleCheckMoves"
            @handleVideoHasEnded="handleVideoHasEnded"
            @handleTriggerFullScreen="handleTriggerFullSize"
            v-bind:single="single"
            :key="flixItem?.id"
          />

          <div
            class="next-prev-container"
            v-if="!single"
          >
            <div
              class="next-prev-container__prev"
              @click.prevent="triggerPrivous"
            >
              <i class="fas fa-chevron-up"></i>
            </div>
            <div
              class="next-prev-container__next"
              @click.prevent="triggerNext"
            >
              <i class="fas fa-chevron-down"></i>
            </div>
          </div>
        </div>
        <div
          class="video-container"
          v-else
        >
          <videoContainerSmall
            :flixItems="flixItem"
            :loadingItem="loadingItem"
            :itemName="flix?.name"
            :totalItems="flix?.items?.length"
            :currentItemCount="currentItemNumber"
            :access="access"
            @handleSwipeChange="handleSwipeChange"
            @openPlansModal="triggerPlansModal"
            v-bind:single="single"
            :key="flixItem[0]?.id"
          />
        </div>
      </div>
      <div :class="[isFull ? 'd-none' : 'col-5', 'col-transitions']">
        <div class="short-details">
          <div class="short-details__title">
            <h1>{{ flix.name ?? flix.title }}</h1>
          </div>
          <div class="short-details__description">
            <span
              class="short-details__trigger_description"
              @click.prevent="showDescription"
            >
              Brief Introduction
              <i class="fas fa-chevron-circle-down"></i>
            </span>
            <p
              v-if="!showDetails"
              class="show_details"
            >
              {{ flix.description }}
            </p>
          </div>
          <div class="short-details__likes_share">
            <div
              class="short-details__likes"
              @click.prevent="handleAddLike"
            >
              <i
                class="fas fa-heart"
                aria-hidden="true"
              ></i>
              <span>{{ countLikes(count_likes) }}</span>
            </div>
            <div
              class="short-details__share"
              @click.prevent="sharePopup"
            >
              <i class="fas fa-share-alt"></i>
              <span>Share</span>
            </div>

            <div
              class="short-details__comments"
              @click="handleOpenComments"
            >
              <i class="fas fa-comment"></i>
              <span>Comments</span>
            </div>
          </div>
        </div>
        <div class="episode_content">
          <span class="episode_counts">
            {{ 1 }} - {{ flix?.items?.length ?? 1 }}
          </span>
          <div class="list_episodes_btns">
            <button
              v-if="single"
              class="btn btn-sm btn-outline--info"
              @click.prevent="getFlixItem(flix?.id)"
            >
              <activeLoader v-if="loadingItem" />
              <span v-else>
                {{ 1 }}
              </span>
              <span
                class="lock-icon"
                v-if="access === false"
              >
                <i class="fas fa-lock"></i>
              </span>
            </button>

            <button
              v-else
              class="btn btn-sm btn-outline--info"
              v-for="(item, index) in flix?.items"
              :key="index"
              @click.prevent="getFlixItem(item?.id)"
            >
              <activeLoader v-if="activeItemId == item?.id" />
              <span v-else>
                {{ index + 1 }}
              </span>
              <span
                class="lock-icon"
                v-if="item?.watch === 0 && item?.highlight == 0"
              >
                <i class="fas fa-lock"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
      <ul
        class="shorts-details-mobile-controls-right"
        v-if="showControls"
      >
        <li @click.prevent="handleAddLike">
          <div class="mobile_controls_right_item_icon like"></div>
          <p>{{ countLikes(count_likes) }}</p>
        </li>
        <li @click.prevent="mobileList">
          <div class="mobile_controls_right_item_icon list"></div>
          <p>List</p>
        </li>
        <li @click.prevent="handleOpenComments">
          <div class="mobile_controls_right_item_icon comments"></div>
        </li>
        <li @click.prevent="sharePopup">
          <div class="mobile_controls_right_item_icon share"></div>
          <p>Share</p>
        </li>
      </ul>

      <div
        class="list-wrapper"
        v-if="showMobileList"
        ref="listWrapper"
      >
        <div
          :class="['list-wrapper__content', showMobileList ? 'show' : 'hide']"
        >
          <div class="list-wrapper__container">
            <div class="list-wrapper__body">
              <div class="list-wrapper-header">
                <span class="chapter-title">
                  List
                  <p class="list-count">Completed({{ flix?.items?.length }})</p>
                </span>
                <svg
                  fill-rule="evenodd"
                  @click.prevent="mobileList"
                  viewBox="64 64 896 896"
                  focusable="false"
                  data-icon="close"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    d="M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"
                  ></path>
                </svg>
              </div>
              <div class="list-wrapper-body-content">
                <div class="list-wrapper-body-content_title episode_counts">
                  {{ 1 }} - {{ flix?.items?.length }}
                </div>
                <div class="list_episodes_btns">
                  <button
                    class="btn btn-sm btn-outline--info"
                    v-for="(item, index) in flix?.items"
                    :key="index"
                    @click.prevent="
                      handleNextItemButtonClicked(item?.id, index)
                    "
                  >
                    <activeLoader v-if="activeItemId == item?.id" />
                    <span v-else>
                      {{ index + 1 }}
                    </span>
                    <span
                      class="lock-icon"
                      v-if="item?.watch == 0 && item?.highlight == 0"
                    >
                      <i class="fas fa-lock"></i>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ShareModal
        :item="flix"
        name="User"
        :has_episode="false"
        :is_flix="true"
        @closeModal="closeShareModal"
        :single="single"
        v-if="flixItem"
      />

      <PlansModal
        :item="flix"
        name="Plans"
        :single="single"
        @closeModal="triggerClosePlansModal"
      />

      <CommentsModal
        :playlist_id="flix.id"
        :show_comments="showComments"
        @hideModal="closeComments"
        :is-auth="isAuth === 1"
        :single="single"
        :key="flix.id"
      />
      <div
        class="show_skipping_message"
        v-if="showSkipMessage"
      >
        <span> You are Skipping Good Story between </span>
      </div>
    </div>
  </div>
</template>

<script>
import VideoContainer from './video-container.vue';
import activeLoader from './components/active-loader.vue';
import ShareModal from '../creator/components/share-modal.vue';
import PlansModal from './components/plans-modal.vue';
import CommentsModal from './components/comments.vue';
import VideoContainerSmall from './video-small-device.vue';

import axios from 'axios';

export default {
  components: {
    VideoContainer,
    activeLoader,
    ShareModal,
    PlansModal,
    CommentsModal,
    VideoContainerSmall,
  },
  name: 'Shorts',
  props: {
    flix: {
      type: Object,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'https://via.placeholder.com/1920x1080',
    },
    item_id: {
      type: Number | String | null,
      default: null,
    },
    isAuth: {
      type: Number,
      required: false,
      default: 0,
    },
    single: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      flixItem: [] | null,
      loadingItem: true,
      showDetails: true,
      activeItemId: null,
      showMobileList: false,
      currentItemNumber: 1,
      showShareModal: false,
      count_likes: 0,
      access: false,
      view_payment_modal: false,
      showControls: true,
      is_small_device: false,
      startIndex: 0,
      endIndex: 2,
      nextItem: null,
      showComments: false,
      showSkipMessage: false,
      isFull: false,
    };
  },

  created() {
    if (window.innerWidth <= 768) {
      this.is_small_device = true;
    }

    this.getFlixItem(this.item_id);
    if (this.item_id == null) {
      this.handleCheckPaymentStatus();
    } else {
      this.handleCheckPaymentStatus('item', this.item_id);
    }
  },
  mounted() {
    if (window.innerWidth <= 768) {
      this.is_small_device = true;
    }

    this.count_likes = this.flix.count_likes;
    document.addEventListener('click', this.closeMobileList);
  },

  methods: {
    async getFlixItem(item_id = null, loadbefore = false) {
      if (loadbefore) {
        this.loadingItem = false;
      } else this.loadingItem = true;

      try {
        var url;
        if (item_id === null) {
          if (this.single == true) {
            url = `/flix/item?small_device=${this.is_small_device}&item_id=${this.flix?.id}&small_device=${this.is_small_device}`;
          } else
            url = `/flix/item?playlist_id=${this.flix?.id}&small_device=${this.is_small_device}`;
        } else {
          !loadbefore && this.pushHistoryUrl(item_id);
          if (this.single) {
            url = `/flix/item?item_id=${item_id}&small_device=${this.is_small_device}`;
          } else
            url = `/flix/item?playlist_id=${this.flix?.id}&item_id=${item_id}&small_device=${this.is_small_device}`;
          this.handleCheckPaymentStatus('item', item_id);
        }

        const response = await axios.get(url);
        this.handleNextItemStructure(response, item_id, loadbefore);
      } catch (error) {
        console.log(error, 'testing');
      }
    },

    handleNextItemStructure(response, item_id, loadBefore) {
      if (loadBefore) {
        this.nextItem = response;
      } else {
        if (item_id !== null && !this.single) {
          this.pushHistoryUrl(item_id);
          // this.handleCheckPaymentStatus('item', item_id);
        }
        this.flixItem = response?.data?.item;

        if (this.is_small_device) {
          this.activeItemId = response?.data?.item[0]?.id;
        } else {
          this.activeItemId = response?.data?.item?.id;
        }

        if (!this.single) {
          var indexOfActive = this.flix?.items?.findIndex(
            (item) => item.id === this.activeItemId,
          );
          this.currentItemNumber = indexOfActive + 1;
        }

        this.loadingItem = false;
      }
    },

    handleVideoHasEnded() {
      if (!this.single)
        this.handleNextItemStructure(
          this.nextItem,
          this.nextItem?.data?.item?.id,
          false,
        );
    },

    showDescription() {
      this.showDetails = !this.showDetails;
    },

    mobileList() {
      this.showMobileList = !this.showMobileList;
    },

    closeMobileList(event) {
      if (
        this.showMobileList &&
        this.$refs.listWrapper &&
        this.$refs.listWrapper.contains(event.target)
      ) {
        this.showMobileList = false;
      }
    },

    sharePopup() {
      this.showShareModal = true;
      $(`#shareModal${this.flix.id}`).modal('show');
    },
    closeShareModal() {
      this.showShareModal = false;
      $(`#shareModal${this.flix.id}`).modal('hide');
    },

    countLikes(likes) {
      if (likes > 1000) {
        return (likes / 1000).toFixed(1) + 'k';
      } else {
        return likes;
      }
    },

    async handleAddLike() {
      try {
        const response = await axios.post(`/flix/like`, {
          flix_id: this.flix.id,
          single: this.single,
        });

        this.count_likes = this.count_likes + response.data.value;
      } catch (error) {
        console.log(error.message, 'tesso');
      }
    },

    async handleCheckPaymentStatus(type = 'playlist', item_id = 0) {
      var payload = {};
      if (this.single) {
        payload = {
          item_id: item_id,
        };
      } else {
        if (type === 'playlist') {
          payload = {
            flix_playlist_id: this.flix.id,
          };
        } else if (type == 'item') {
          payload = {
            item_id: item_id,
          };
        } else {
          payload = {
            flix_playlist_id: this.flix.id,
          };
        }
      }

      const item =
        this.flix?.items?.find((item) => item.id === item_id) ?? null;

      try {
        const url = `/user/verify-subscription`;
        const response = await axios.post(url, {
          ...payload,
        });

        const result = response.data;
        if (result.status === 'success') {
          const accessToBolean = result?.data?.access == 1 ? true : false;
          if (!result?.data?.access) {
            if (item && item.highlight == 0 && !this.single) {
              this.triggerPlansModal();
            }
            if (this.single && accessToBolean === false) {
              this.triggerPlansModal();
            }
            this.access = accessToBolean;
          } else {
            this.access = accessToBolean;
          }
        } else {
          console.log('error', result.message);
        }
      } catch (error) {
        console.log(error.message, 'tesso');
      }
    },

    pushHistoryUrl(item_id) {
      const current_url = window.location.href;
      const newItemId = item_id;
      const currentItemId = new URLSearchParams(window.location.search).get(
        'item_id',
      );

      const hasItemId = new RegExp('([?&])item_id=' + currentItemId).test(
        current_url,
      );
      const updatedUrl = hasItemId
        ? current_url.replace(/([?&])item_id=[^&]+/, '$1item_id=' + newItemId)
        : current_url +
          (current_url.indexOf('?') > 0 ? '&' : '?') +
          'item_id=' +
          newItemId;

      window.history.pushState({}, '', updatedUrl);
    },

    triggerPlansModal() {
      this.view_payment_modal = true;
      $(`#plans-modal-${this.flix.id}`).modal('show');
    },

    triggerClosePlansModal() {
      this.view_payment_modal = false;
      $(`#plans-modal-${this.flix.id}`).modal('hide');
    },

    handleCheckLockedItem(access, item) {
      if (item?.highlight === 1) {
        return false;
      } else {
        return !access && item?.highlight === 0;
      }
    },

    triggerNext(loadbefore = false) {
      if (!this.single) {
        const currentActiveIndex = this.flix?.items?.findIndex(
          (item) => item.id === this.activeItemId,
        );
        const nextItem = this.flix?.items[currentActiveIndex + 1];
        if (nextItem) {
          this.getFlixItem(nextItem?.id);
        }
      } else {
        this.getFlixItem(this.flix.id, true);
      }
    },

    handleCheckMoves(showControls) {
      this.showControls = showControls;
    },

    triggerPrivous() {
      if (!this.single) {
        const currentActiveIndex = this.flix?.items.findIndex(
          (item) => item.id === this.activeItemId,
        );
        const previousItem = this.flix?.items[currentActiveIndex - 1];
        if (previousItem) {
          this.getFlixItem(previousItem?.id);
        }
      }
    },

    handleOpenComments() {
      this.showComments = !this.showComments;
      $(`#commentsModal-${this.flix?.id}`).modal('show');
    },

    closeComments() {
      this.showComments = false;
      $(`#commentsModal-${this.flix?.id}`).modal('hide');
    },

    async handleGetSwiperImages() {
      try {
        let url;
        const currentItemId = new URLSearchParams(window.location.search).get(
          'item_id',
        );
        if (currentItemId) {
          url = `/flix/item-image?playlist_id=${this.flix?.id}&item_id=${currentItemId}`;
        } else {
          url = `/flix/item-image?playlist_id=${this.flix?.id}`;
        }
        const response = await axios.get(url);
        this.item_images = response.data.items;
      } catch (error) {
        console.log(error);
      }
    },
    handleSwipeChange(index) {
      const currentActiveIndex = this.flix?.items.findIndex(
        (item) => item.id === this.activeItemId,
      );
      this.activeItemId = this.flix?.items[index]?.id;
      this.currentItemNumber = index + 1;
    },

    handleNextItemButtonClicked(item_id, index) {
      const firstItemIndexLocked = this.flix?.items.findIndex(
        (item) => item.highlight == 0,
      );
      const itemHasAccess = this?.flix?.items[index].watch == 1;
      if (firstItemIndexLocked === index && itemHasAccess) {
        this.triggerPlansModal();
        return;
      } else if (firstItemIndexLocked !== index && !itemHasAccess) {
        notify('info', 'you are skipping alot content');
        return;
      } else {
        this.getFlixItem(item_id);
      }
    },
    handleTriggerFullSize() {
      this.isFull = !this.isFull;
    },
  },

  beforeDestroy() {
    document.removeEventListener('click', this.closeMobileList);
  },
};
</script>

<style scoped>
.col-7 {
  padding: 0;
}

.shorts-details-mobile-controls-right {
  display: none;
}

@media screen and (max-width: 768px) {
  .list-wrapper-body-content {
    padding: 0 20px;
  }
  .shorts-details-mobile-controls-right li p {
    font-size: 14px;
  }

  .list-wrapper-body-content_title {
    margin-top: 10px;
  }
  .list-wrapper-body-content .list_episodes_btns {
    border-top: 1px solid #404040;
    padding-top: 10px;
    margin-top: 10px;
    overflow: scroll;
    max-height: 73.06667vw;
    margin-top: 4.8vw;
    display: grid;
    grid-template-columns: repeat(5, 18.5%);
    grid-column-gap: 1.6vw;
    grid-row-gap: 2.66667vw;
    overflow-y: scroll;
    overflow-x: hidden;
    touch-action: pan-y;
  }

  .list-wrapper-body-content .list_episodes_btns::-webkit-scrollbar {
    width: 2px !important;
  }

  .list-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    max-height: -webkit-fill-available;
    background-color: #0000007c;
    z-index: 3;
    padding-right: 0;
  }

  .list-wrapper__content {
    position: absolute;
    left: 0;
    width: 100%;
    height: 420px;
    overflow-y: scroll;
    z-index: 3;
    transition: transform 0.3s ease-in-out;
    bottom: 0;
    inset-inline: 0;
    box-shadow: 0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12), 0 -9px 28px 8px rgba(0, 0, 0, 0.05);
    transform: translateY(100%);
  }
  .list-wrapper__content.show {
    transform: translateY(0%);
  }
  .list-wrapper__content.hide {
    transform: translateY(100%);
  }

  .list-wrapper__container {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 10px 10px 0 0;
    background-color: #222 !important;
  }
  .list-wrapper__body {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }

  .list-wrapper-header {
    display: flex;
    flex: 0;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px;
    font-size: 16px;
    line-height: 1.5;
    border: none;
    padding-bottom: 0;
    padding-left: 0;
    margin-left: 4.8vw;
  }
  .list-wrapper-header .chapter-title {
    font-size: 1.2em;
    font-weight: 700;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .list-wrapper-header .list-count {
    font-size: 0.8em;
    font-weight: 700;
    color: #95928e;
    margin-left: 10px;
  }

  .shorts-details-mobile-controls-right {
    position: absolute;
    width: 9.06667vw;
    right: 20px;
    bottom: 30%;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .shorts-details-mobile-controls-right li {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.33333vw;
    width: 100%;
    font-size: 1.2em;
    font-weight: 700;
    color: #fff;

    &:hover {
      cursor: pointer;
    }
  }
  .shorts-details-mobile-controls-right li .mobile_controls_right_item_icon {
    position: relative;
    height: 8vw;
    width: 8vw;
    background-size: 100% 100%;
  }
  .shorts-details-mobile-controls-right
    li
    .mobile_controls_right_item_icon.like {
    background-image: url('/images/vue/heart.png');
  }
  .shorts-details-mobile-controls-right
    li
    .mobile_controls_right_item_icon.share {
    background-image: url('/images/vue/share.png');
  }

  .shorts-details-mobile-controls-right
    li
    .mobile_controls_right_item_icon.list {
    background-image: url('/images/vue/list.png');
  }

  .shorts-details-mobile-controls-right
    li
    .mobile_controls_right_item_icon.comments {
    background-image: url('/images/vue/comment.png');
  }

  .shorts-details-mobile-controls-right li p {
    font-weight: 700;
    margin-right: 7px;
  }
}
.normal-container {
  position: relative;
}
.short-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
.video-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  height: 100vh;
  position: relative;
}

@media screen and (max-width: 768px) {
  .video-container {
    max-height: 100%;
    height: 100%;
  }
}
.video-container__image {
  background-color: #000;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.video-container__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-container__image::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(10px);
  z-index: 1;
}

.short-details {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-top: 4em;
  padding-left: 30px;
}

.short-details__title h1 {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-family: Sofia Pro, -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
    'Helvetica', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell',
    'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.short-details__likes_share {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}
.short-details__likes {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-right: 30px;

  &:hover {
    cursor: pointer;
  }
}

.short-details__comments {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-left: 30px;

  &:hover {
    cursor: pointer;
  }
}

.short-details__comments i,
span {
  color: #fff;
  font-size: 14px;
  font-weight: 700;
}

.short-details__comments span {
  margin-left: 10px;
}

.short-details__likes i {
  color: #fff;
  margin-right: 10px;
}

.short-details__likes span {
  color: #fff;
  font-size: 14px;
  font-weight: 700;
}

.short-details__share {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
  }
}

.short-details__share i {
  color: #fff;
  margin-right: 10px;
}

.short-details__share span {
  color: #fff;
  font-size: 14px;
  font-weight: 700;
}

.short-details__description {
  width: 100%;
  margin-top: 9px;
}
.short-details__trigger_description {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  color: #ababab;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 20px;

  &:hover {
    cursor: pointer;
  }

  i {
    margin-left: 5px;
  }
}

.show_details {
  color: #ababab;
  font-size: 14px;
  font-weight: 700;
  transition: 0.2s;
  transition-timing-function: ease-in-out;

  &:hover {
    color: #fff;
  }
}

.episode_content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 20px;
  margin-left: 30px;
  width: 100%;
}

.episode_counts {
  color: #86fff5;
  font-size: 14px;
  font-weight: 900;
  margin-right: 20px;
  position: relative;
}

.episode_counts::after {
  content: '';
  position: absolute;
  bottom: -3px;
  width: 16px;
  height: 3px;
  left: 8px;
  background-color: #86fff5;
}
.list_episodes_btns {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;
  width: 100%;
  flex-wrap: wrap;
}
.list_episodes_btns button {
  margin-right: 10px;
  margin-bottom: 10px;
}
.btn {
  width: 56px;
  height: 42px;
  background: hsla(0, 0%, 100%, 0.16);
  font-size: 20px;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  border-radius: 6px 6px 6px 6px;
  position: relative;
  overflow: hidden;
}
.lock-icon {
  position: absolute;
  top: 0;
  right: 0;
  width: 18px;
  height: 14px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 8px;
  font-weight: 700;
  background-color: #f00;
  border-radius: 0px 0px 0px 10px;
  i {
    margin-left: 2px;
  }
}

@media screen and (max-width: 768px) {
  .col-5 {
    display: none;
  }
  .col-7 {
    width: 100%;
  }
}

@media screen and (max-width: 768px) {
  .large-device {
    display: none;
  }
}

.small-device {
  display: none;
}

@media screen and (max-width: 768px) {
  .small-device {
    display: block;
  }
}

.next-prev-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex-wrap: nowrap;
  position: absolute;
  bottom: 20%;
  right: 10%;
  z-index: 2;
  gap: 10px;
}

.next-prev-container__prev,
.next-prev-container__next {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background-color: #0000007c;
  border-radius: 50%;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
}

.next-prev-container__prev:hover,
.next-prev-container__next:hover {
  background-color: #000000;
}

.next-prev-container__prev i,
.next-prev-container__next i {
  font-size: 20px;
}

@media screen and (max-width: 768px) {
  .next-prev-container {
    display: none;
  }
}
.show_skipping_message {
  position: absolute;
  top: 50%;
  z-index: 99;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  font-weight: 900;
  font-size: 2rem;
  margin-left: 10px;
  margin-right: 37px;
  padding: 10px;
  padding: 20px;
  letter-spacing: 1px;
  padding-top: 10px;
}
.show_skipping_message span {
  padding: 20px;
  font-size: 1.5rem;
}

.mobile_controls_right_item_icon.comments {
  font-size: 20px;
}

.col-transitions {
  transition: all 0.5s ease-in-out;
  transition-timing-function: ease-in-out;
}
</style>
